import { onMounted, onUnmounted } from 'vue'

export default (
  elementSelector: string,
  action: Function = () => {},
  eventType: 'click' | 'mousedown' = 'click'
) => {
  const clickHandler = (event): void => {
    const elements = document.querySelectorAll(elementSelector)

    if (elements.length === 0) {
      return
    }
    
    const checks: boolean[] = [...elements].map(el => {
      return eventWithinElement(event, el)
    })

    const isAway = checks.every(c => c === false)

    if (isAway) {
      action()
    }
  }

  onMounted(() => {
    addClickAway(clickHandler, eventType)
  })

  onUnmounted(() => {
    removeClickAway(clickHandler, eventType)
  })

  return {}
}

function addClickAway(handler: any, eventType: 'click' | 'mousedown' = 'click'): void {
  document.addEventListener(eventType, handler, true)
}

function removeClickAway(handler: any, eventType: 'click' | 'mousedown' = 'click'): void {
  document.removeEventListener(eventType, handler, true)
}

function eventWithinElement(event, element): boolean {
  if (element === event.target || element.contains(event.target)) {
    return true
  }
  
  const elements = document.elementsFromPoint(event.clientX, event.clientY)
  return elements.includes(element) || 
         Array.from(elements).some(el => element.contains(el))
}

